<div class="error-view">
    <h2 class="error">{{'error.fullLabel' | translate}}</h2>
    <h3 *ngIf="code && message">{{ code }} - {{ message }}</h3>
    <div [innerHTML]="'error.detail' | translate | replace : '{#email}' : email"></div>
</div>
